import { Helmet } from 'react-helmet-async';
import { useEffect, useRef, useState } from 'react';
import { Stack, Button, Container, TextField, FormControl, Select, InputLabel, MenuItem, Checkbox, IconButton, DialogTitle, DialogContent, DialogActions, Table, Dialog, TableContainer, TableBody, TableRow, TableCell, TableHead, Divider, Typography, Grid, Box } from '@mui/material';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator, timelineItemClasses } from '@mui/lab';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { saveAs } from 'file-saver'
import { FaEye, FaTrashAlt, FaDownload, FaRoute, FaListUl } from 'react-icons/fa';
import { getEduteckInvoiceList, getInvoiceExcel, importAwbReport, getInvoiceDetails, getOrderTrackingByAwb, getOrderComments, addSubStatus, generateLabel } from '../Servies/AdmiServices';
import TableData from '../components/common/TableData';
import Loader from '../components/common/Loader';



export default function EduteckInvoiceList() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const headers = ['Order Id', 'Invoice Number', 'Transaction Date', 'Customer Name', 'Product Id','Product Name', 'Amount', 'Invoice No', 'Order Status', 'Action'];
  const [showTable, setShowTable] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPageSize, setTotalPageSize] = useState(1)
  const [isLoading, setIsLoading] = useState(false);
  const [orderStatus, setOrderStatus] = useState('All');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [addAwbData, setAddAwbData] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [trackModalOpen, setTrackModelOpen] = useState(false)
  const [trackData, setTrackData] = useState(null)
  const [sCommentOpen, setsCommentOpen] = useState(false)
  const [sCommentData, setsCommentData] = useState({ id: null, data: null });
  const [shipComment, setShipComment] = useState('')

  const handleChange = (event) => {
    setOrderStatus(event.target.value);
  };

  const handleStartDateChange = (event) => {
     setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleNameChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      fetchInvoices();
    }
  };

  const fetchInvoices = async () => {
    setIsLoading(true);
   

    try {
      const response = await getEduteckInvoiceList({
        page: pageNo - 1,
        length: pageSize,
        search,
        order: [[0, 'desc']],
        data: {
          orderStatus: orderStatus === 'All' ? '' : orderStatus,
          fromDate: startDate,
          toDate: endDate,
        },
      });
      setShowTable(response.data.response);
      setTotalRecords(response.data.response.length);
      setTotalPageSize(response.data.response.length);
    } catch (error) {
      toast.error('Failed to fetch invoice data');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadCSV = () => {
    if (!showTable || showTable.length === 0) {
      toast.warn('No data available to download');
      return;
    }
  
    const headers = Object.keys(showTable[0]);
    const csvRows = [];
  
    // Add headers
    csvRows.push(headers.join(','));
  
    // Add rows using .forEach
    showTable.forEach(row => {
      const values = headers.map(header => {
        const val = row[header];
        return `"${String(val).replace(/"/g, '""')}"`;
      });
      csvRows.push(values.join(','));
    });
  
    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
  
    const date = new Date();

    const currentDate = `${date.getFullYear()}_${String(date.getMonth() + 1).padStart(2, '0')}_${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}-${String(date.getMinutes()).padStart(2, '0')}-${String(date.getSeconds()).padStart(2, '0')}`;

    const link = document.createElement('a');
    link.href = url;
    link.download = `eduteck-invoice-date-${currentDate}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  
  const handleSearchClick = () => {
    setPageNo(1); // Reset to first page on new search
    fetchInvoices();
  };

  useEffect(() => {
    fetchInvoices();
  }, [pageNo, pageSize]);

  const handleCheckboxChange = (invoiceNumber) => {
    setSelectedInvoices((prevSelected) =>
      prevSelected.includes(invoiceNumber)
        ? prevSelected.filter((num) => num !== invoiceNumber)
        : [...prevSelected, invoiceNumber]
    );
  };


  const downloadInvoices = async (invoiceNumber) => {
    const invoicesToDownload = selectedInvoices.length > 0 ? selectedInvoices : [invoiceNumber];
    console.log(selectedInvoices)
    if (invoicesToDownload.length > 0) {
      try {
        const response = await getInvoiceExcel(invoicesToDownload);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        // Generate current date string
        const currentDate = new Date().toLocaleDateString('en-GB').split('/').reverse().join('-');
        // Create the file name with the current date
        const fileName = `ShipRocket_${currentDate}.zip`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading the file');
        toast.error('Error downloading the file');
      }
    } else {
      toast.warn('No invoices selected');
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setUploadedFile(file);
  };

  const handleFormSubmit = () => {
    const file = uploadedFile;
    setIsLoading(true);
    // Assuming you have a function like addQuizImport that accepts additional parameters
    importAwbReport(file)
      .then((response) => {
        if (response.data && response.data.success) {
          setAddAwbData(response.data);
          toast.success('File uploaded successfully!');
        } else {
          console.error('Unexpected response structure:', response.data);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('AddCourse error:', error);
      });
  };

  const viewInvoiceDetails = async (OrderId) => {
    setIsLoading(true)
    try {
      getInvoiceDetails(OrderId).then((res) => {
        console.log(res.data.status)
        if (res.data.status === "SUCCESS") {
          setInvoiceData(res.data.response)
          setInvoiceOpen(true)
          console.log(res.data)
          setIsLoading(false)
        } else {
          toast.error("Error Getting Invoice Details...")
          setIsLoading(false)
        }

      });
    } catch (error) {
      console.log("Error Occured:", error)
      setIsLoading(false)
    }
  }

  const viewInvoiceTrack = async (awbNumber, partnerId) => {
    setIsLoading(true)
    try {
      getOrderTrackingByAwb(awbNumber, partnerId).then((res) => {
        if (res.data.status === "SUCCESS") {
          console.log(res.data.response);
          setTrackData(res.data.response);
          setTrackModelOpen(true);
          setIsLoading(false)
        } else {
          toast.error("Error Getting Order Details...")
          setIsLoading(false)
        }
      })
    } catch (error) {
      console.log("Error occured::", error)
      setIsLoading(false)
    }

  }

  const viewShipComment = async (id) => {
    setIsLoading(true)
    try {
      getOrderComments(id).then((res) => {
        if (res.data.status === "SUCCESS") {
          const commentData = { id, data: res.data.response }
          setsCommentData(commentData);
          setsCommentOpen(true)
          setIsLoading(false)
        } else {
          // toast.error(res.data.message)
          const commentData = { id, data: null }
          setsCommentData(commentData);
          setsCommentOpen(true)
          setIsLoading(false)
        }
      })
    } catch (error) {
      console.log("Error occured::", error)
      setIsLoading(false)

    }
  }

  const addNewShipComment = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const data = { "subStatus": shipComment, "portalTransactionId": sCommentData.id }
      addSubStatus(data).then((res) => {
        if (res.data.status === "SUCCESS") {
          setsCommentOpen(false);
          toast.success("Comment added");
          setIsLoading(false)
        } else {
          setIsLoading(false)
          toast.error("Error while adding comment")
        }
      })
    } catch (error) {
      setIsLoading(false)
      console.log("Error Occured::", error)
    }
  }

  console.log('addAssessData', addAwbData);

  const labelGeneration = (shipmentId) => {
    const data = {
      "shipment_id": [`${shipmentId}`],
      "partner_id": 3
    }
    console.log("labelGeneration:", data)
    generateLabel({ "abc": "abc" }).then((res) => {
      console.log(res.data)
      downloadLabelPDF(res.data.label_url)
    })
  }

  const downloadLabelPDF = async (labelUrl) => {
    try {
      const response = await axios({
        url: labelUrl,
        method: 'GET',
        responseType: 'blob',
      });

      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      saveAs(pdfBlob, 'shipping-label.pdf');
    } catch (error) {
      console.error('Error downloading the PDF:', error);
    }
  };

  const specificColumns = Array.isArray(showTable)
    ? showTable.map((item, index) => {
      return {
        'Order Id': item.pgOrderId,
        'Invoice Number': item.invoiceNumber !== "" ? item.invoiceNumber : "-",
        'Transaction Date': formatDate(item.transactionDate),
        'Customer Name': item.customerName,
        'Product Id': item.productId,
        'Product Name': item.productName, 
        'Amount': item.transactionAmount,
        'Invoice No': item.invoiceNumber,
        'Order Status': item.orderStatus !== "" ? item.orderStatus : "-",
        Action: (
          <div style={{ display: 'flex' }}>
            <FaDownload style={{ cursor: 'pointer', marginRight: '10px' }} title='Download Invoice' onClick={() => { window.open(item.invoiceLink, '_blank') }} />
            <FaEye style={{ cursor: 'pointer', marginRight: '10px' }} title='View Invoice' onClick={() => { viewInvoiceDetails(item.pgOrderId) }} />
          </div>
        ),
        // 'Dispatch Order': (
        //   <div>
        //     <Button variant="contained" color="primary" onClick={() => { navigate('/dashboard/CreateShipment', { state: { order: item } }) }}> Create Shipment </Button>
        //     <Button variant="contained" color="primary" onClick={() => { navigate('/dashboard/GenerateAWB', { state: { order: item } }) }}> Generate AWB Shipment </Button>
        //   </div>
        // ),
        // 'Generate Label': (
        //   <div>
        //     <Button variant="contained" color="primary" onClick={() => { labelGeneration(12333) }}>Generate</Button>
        //   </div>
        // )

      };
    })
    : [];

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <Helmet>
        <title> Client </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Eduteck Invoices Data</Typography>
        </Stack>
        <div style={{ display: 'flex', gap: '2rem' }}>
          <FormControl style={{ width: '200px' }}>
            <InputLabel id="demo-simple-select-autowidth-label">Order Status</InputLabel>
            <Select labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={orderStatus} onChange={handleChange}
              autoWidth label="Order Status"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="InProcess">InProcess</MenuItem>
              <MenuItem value="Ready To Dispatch">Ready To Dispatch</MenuItem>
              <MenuItem value="Dispatched">Dispatched</MenuItem>
              <MenuItem value="AWB Received">AWB Received</MenuItem>
              <MenuItem value="Delivered">Delivered</MenuItem>
              <MenuItem value="Order Cancelled">Order Cancelled</MenuItem>
              <MenuItem value="Failed">Failed</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
            </Select>
          </FormControl>
          <TextField id="start-date"
            label="Start Date" type="date" value={startDate}
            onChange={handleStartDateChange} InputLabelProps={{ shrink: true, }}
          />
          <TextField id="end-date" label="End Date" type="date"
            value={endDate} onChange={handleEndDateChange} InputLabelProps={{ shrink: true, }}
          />
          <Button variant="contained" color="primary" onClick={handleSearchClick}> Search </Button>
        </div>
        <br />
        <div style={{ display: 'flex', gap: '2rem' }}>
          
          <Button variant="contained" color="primary" onClick={downloadCSV}>
            Export Data
          </Button>
          <TextField
            id="search-name"
            label="Search by Name"
            type="text"
            value={search}
            onChange={handleNameChange}
            onKeyDown={handleSearchKeyPress}
            style={{ marginLeft: '500px' }}
          />
          <FormControl style={{ width: '150px' }}>
            <InputLabel id="page-size-select-label">Page Size</InputLabel>
            <Select
              labelId="page-size-select-label"
              id="page-size-select"
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
              autoWidth
              label="Page Size"
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={totalPageSize}>All</MenuItem>
            </Select>
          </FormControl>
        </div>
        <br />
        <TableData
          data={specificColumns}
          headers={headers}
          rowsPerPageOptions={[5, 10, 20]}
          page={pageNo}
          pageSize={pageSize}
          totalRecords={totalRecords}
          onPageChange={(newPage) => setPageNo(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        />
        <br />
        <Dialog maxWidth={'md'} scroll={'body'} fullWidth open={invoiceOpen} onClose={() => { setInvoiceOpen(false) }}>
          <DialogTitle>Invoice Details</DialogTitle>
          <Divider />
          {invoiceData && <DialogContent>
            <Typography><strong> User Info: </strong></Typography>
            <p style={{ marginTop: 0 }}>Customer Name : {invoiceData?.customerName} <br />
              Customer Email : {invoiceData?.email} <br />
              Customer Mobile : {invoiceData?.contactNo} <br />
            </p>
            <Typography><strong> Delivery Address: </strong></Typography>
            <p style={{ marginTop: 0 }}>Address: {invoiceData?.address1}, {invoiceData?.address2}, {invoiceData?.address3} <br />
              City : {invoiceData?.city}, {invoiceData?.state} - {invoiceData?.pinCode} <br />
            </p>
            <Typography><strong> Product Details: </strong></Typography>
            <p style={{ marginTop: 0 }}>Product ID : {invoiceData?.productId} <br />
              Product Title : {invoiceData?.productTitle} <br />
              Quantity: {invoiceData?.quantity} <br />
              Total Value : {invoiceData?.totalsalevalue}
            </p>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><Typography variant="body1">Subject Name</Typography></TableCell>
                    <TableCell><Typography variant="body1">Product Id</Typography></TableCell>
                    <TableCell><Typography variant="body1">Product Name</Typography></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoiceData?.productList.map((product) => {
                    return (
                      <TableRow key={`key${product.id}`}>
                        <TableCell><Typography variant="body1">{product.subjectName}</Typography></TableCell>
                        <TableCell><Typography variant="body1">{product.productId}</Typography></TableCell>
                        <TableCell><Typography variant="body1">{product.courseDisplayName}</Typography></TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>}
          <DialogActions>
            <Button onClick={() => { setInvoiceOpen(false) }} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
 

      </Container>
    </>
  );
}
